module.exports = __webpack_public_path__ + "fonts/NunitoSans-Bold.022586a.ttf";